import React, { useState } from 'react'
import Portal from '../Portal/Portal'
import CleverAlphaButton from '../CleverAlphaButton/CleverAlphaButton'
import Overlay from '../Overlay/Overlay'
import { Spinner } from '../../funcs/utils'

const ConfirmationModal = ({ children, title, content, handleSubmit = () => {} }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const handleOpenModal = () => {
        setIsOpen(true);
    }

    // use for modal in overlay
    const handleCloseModal = () => {
        setIsOpen(false);
    }
    
    const handleSubmitModal = async () => {
        setIsSubmitting(true);
        const handleClose = await handleSubmit();
        setIsSubmitting(false);
        setIsOpen(false);
        handleClose();
    }

    return (
        <React.Fragment>
            <CleverAlphaButton onClick={handleOpenModal}>
                {children}
            </CleverAlphaButton>
            
            {isOpen && 
                <Portal isNested={true}>
                    <Overlay>
                        {isSubmitting && <Overlay><Spinner size="36px"/></Overlay>}

                        <div style={{ width: "40%", padding: "24px", backgroundColor: "white", border: "1px solid black" }}>
                            <div>Portfolio Adjustment</div>
                            <div>{title}</div>
                            <div style={{ margin: "16px 0"}}>{content}</div>
                            <div style={{ display: "flex", justifyContent: "center"}}>Are you sure you want to proceed?</div>
                            <div style={{ display: "flex", justifyContent: "center", gap: "16px", marginTop: "16px" }}>
                                <CleverAlphaButton onClick={handleCloseModal}>Cancel</CleverAlphaButton>
                                <CleverAlphaButton onClick={handleSubmitModal}>Yes</CleverAlphaButton>
                            </div>
                        </div>
                    </Overlay>
                </Portal>
            }
            
        </React.Fragment>
        
    )
}

export default ConfirmationModal